function CheckoutHeaderSkeleton() {
  return (
    <div className="flex items-end justify-between">
      <div className="bg-grey-100 h-10 w-48 animate-pulse rounded" />
      <div className="flex gap-8">
        <div className="bg-grey-100 h-5 w-20 animate-pulse rounded" />
        <div className="bg-grey-100 h-5 w-10 animate-pulse rounded" />
        <div className="bg-grey-100 h-5 w-32 animate-pulse rounded" />
      </div>
    </div>
  );
}

function CheckoutItemSkeleton() {
  return (
    <div className="flex gap-4">
      <div className="bg-grey-100 size-28 animate-pulse rounded" />
      <div className="bg-grey-100 h-10 w-full animate-pulse rounded" />
    </div>
  );
}

function CheckoutPriceSkeleton() {
  return (
    <div className="flex flex-col items-end gap-2">
      <div className="bg-grey-100 h-5 w-60 animate-pulse rounded" />
      <div className="bg-grey-100 h-5 w-80 animate-pulse rounded" />
      <div className="bg-grey-100 h-5 w-40 animate-pulse rounded" />
    </div>
  );
}

function CheckoutFooterSkeleton() {
  return (
    <div className="mt-10 flex flex-col gap-4 lg:flex-row">
      <div className="bg-grey-100 h-20 w-full animate-pulse rounded" />
      <div className="bg-grey-100 h-20 w-full animate-pulse rounded" />
    </div>
  );
}

export default function CheckoutSkeleton() {
  return (
    <div className="my-10 flex flex-col gap-4 px-4">
      <CheckoutHeaderSkeleton />
      <CheckoutItemSkeleton />
      <CheckoutPriceSkeleton />
      <CheckoutFooterSkeleton />
    </div>
  );
}
